import request from '@/utils/request'

// 获取商户列表数据
export function commList (data) {
  return request({
    url: '/auth/data/commercials/page',
    method: 'post',
    data
  })
}

// 获取运营商
export function operateinfo (data) {
  return request({
    url: '/auth/data/operateinfo/page',
    method: 'post',
    data
  })
}

// 新增商户
export function addCommercials (data) {
  return request({
    url: '/auth/data/commercials',
    method: 'post',
    data
  })
}

// 查询指定商户
export function checkCommercials (id) {
  return request({
    url: `/auth/data/commercials/${id}`,
    method: 'get'
  })
}

// 修改商户
export function updateCommercials (data) {
  return request({
    url: '/auth/data/commercials',
    method: 'put',
    data
  })
}

// 商户管理员修改用户
export function editUser (data) {
  return request({
    url: '/auth/api/commercials/user/edit',
    method: 'post',
    data
  })
}

// 新增运营商
export function addOperateinfo (data) {
  return request({
    url: '/auth/data/operateinfo',
    method: 'post',
    data
  })
}

// 编辑回显运营商
export function editOperateinfo (id) {
  return request({
    url: `/auth/data/operateinfo/${id}`,
    method: 'get'

  })
}

// 修改运营商
export function updateOperateinfo (data) {
  return request({
    url: '/auth/data/operateinfo',
    method: 'put',
    data
  })
}

// 删除运营商
export function deleteOperateinfo (id) {
  return request({
    url: `/auth/data/operateinfo/${id}`,
    method: 'delete'
  })
}
// 新增和编辑时 获取商户级别下拉数据
export function getPreoptionsApi (data) {
  return request({
    url: '/auth/data/commercials/page',
    method: 'post',
    data
  })
}

// 获取 查看下发结果
export function getSentInfListApi (data) {
  return request({
    url: '/dbs/api/boxsetting/getByCommId',
    method: 'post',
    data
  })
}

/**
 * 再次下发，单条
 * @param {选中的数据} data
 */
export function sendQRCodeByIdApi (data) {
  return request({
    url: '/dbs/api/boxsetting/sendQRCodeById',
    method: 'post',
    data
  })
}

/**
 * 失败再次下发，全部
 */
export function sendFailQRCodeApi (data) {
  return request({
    url: '/dbs/api/boxsetting/sendFailQRCode',
    method: 'post',
    data
  })
}

// 获取商户
export function getCommData (data) {
  return request({
    url: '/auth/api/commercials/user/sub',
    method: 'get',
    data
  })
}

/**
 * 获取站点列表
 */
export function getSiteList (data) {
  return request({
    url: '/ant/api/site/getPagedSiteSimpleListOnManager',
    method: 'post',
    data
  })
}

/**
 * 获取脱机桩列表
 */
export function getOfflineEvseList (data) {
  return request({
    url: '/ant/api/OfflineEvse/getEvseList',
    method: 'post',
    data
  })
}

/**
 * 批量新增脱机桩
 */
export function batchAddOfflineEvse (data) {
  return request({
    url: '/ant/api/OfflineEvse/batchAdd',
    method: 'post',
    data
  })
}

/**
 * 更新脱机桩信息
 */
export function updateOfflineEvse (data) {
  return request({
    url: '/ant/api/OfflineEvse/updateEvse',
    method: 'post',
    data
  })
}

/**
 * 移除脱机桩
 */
export function removeOfflineEvse (data) {
  return request({
    url: '/ant/api/OfflineEvse/remove',
    method: 'post',
    data
  })
}

// deprecated
// 原站点列表/详情页面中的列表接口，后更换为别的
// 后期删除getTerminalList
// export function getTerminalList (data) {
//   return request({
//     url: '/dbs/api/charger/getPagedChargerInfoListNoComm',
//     method: 'post',
//     data
//   })
// }

// 站点信息  站点详情的基本信息
export function getSiteBasic (data) {
  return request({
    url: '/dbs/api/site/getSiteDetailBySiteId',
    method: 'post',
    data,
    params: data
  })
}

export function getTemplateDetailById (params) {
  return request({
    url: '/dbs/api/template/getTemplateDetailById',
    method: 'post',
    params
  })
}

/**
 * 站点列表查询条件  获取集团商户列表
 */
export function getMaxCommercialArrayApi () {
  return request({
    url: '/auth/data/commercials/user/getByCommlevel/1',
    method: 'get'
  })
}

/**
 * 站点列表查询条件  获取所属商户列表
 */
export function getCommercialArrayApi (commId) {
  return request({
    url: `/auth/data/commercials/user/getChildByCommId/${commId}`,
    method: 'get'
  })
}

/**
 * 紧急充电卡列表查询
 */
export function getEmergeListApi (data) {
  return request({
    url: `/ant/api/card/urgencyCardsListOnOperate?_index=${data._index}&_size=${data._size}`,
    method: 'post',
    data

  })
}

/**
 * 紧急充电卡 弃用
 */
export function deleteEmergeCardApi (cardChipNo) {
  return request({
    url: `/ant/api/card/abandonWhiteCard?cardChipNo=${cardChipNo}`,
    method: 'get'
  })
}

/** 获取商户列表 */
export function getClientNameList () {
  return request({
    url: '/ant/api/blocUser/selectSubBlocUserByCommIdChain',
    method: 'get'
  })
}

/**
 * 紧急充电卡列表查询
 */
export function getEmergeBasicInfoApi (data) {
  return request({
    url: '/ant/api/card/urgencyCardsDetail',
    method: 'post',
    data
  })
}

/**
 * 紧急充电卡 桩列表
 * @param {*} data
 */
export function urgencyCardsDetailEvseList (data) {
  return request({
    url: '/ant/api/card/urgencyCardsDetailEvseList',
    method: 'post',
    data
  })
}

/**
 * 紧急充电卡 更换密码
 * @param {*} data
 */
export function changePasswordApi (id) {
  return request({
    url: `/ant/api/card/resetWhiteCardPwd?cardChipNo=${id}`,
    method: 'get'
  })
}

export function sendEmergentToPileAgainApi (cardChipNo, siteName) {
  return request({
    url: `/ant/api/card/sendWhiteCard?cardChipNo=${cardChipNo}&siteName=${siteName}`,
    method: 'get'
  })
}

// 获取商户列表数据
export function getSimpleCommList (data) {
  return request({
    url: '/ant/api/comm/getCommList',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/Api/commercial.js